<template>
  <div>
    <div class="d-flex flex-column h-100">
      <div>
        <SystemBar />
        <ViewHeader
          title="Lista de transmisiones"
          :goTo="'/'"
        />
      </div>
      <div class="flex-fill overflow-auto">
        <div>
          <div
            v-if="rooms.loading"
            class="px-6 py-10"
          >
            <Loading message="Buscando trasmisiones disponibles. Por favor espere..." />
          </div>
          <div v-else-if="rooms.data.length">
            <v-list
              subheader
              two-line
            >
              <v-list-item-group active-class="primary--text">
                <template>
                  <div
                    v-for="(room, index) in rooms.data"
                    :key="`room-${index}`"
                  >
                    <v-list-item
                      class="px-5 py-2"
                      three-line
                      @click="goToRoom(room.session.id)"
                    >
                      <template>
                        <div class="d-flex align-center">
                          <div
                            v-if="room.user"
                            class="mr-2"
                          >
                            <Avatar :profileImage="room.user.mainPicture" />
                          </div>
                          <div>
                            <div
                              class="text--secondary"
                              style="line-height: 1"
                            >
                              <small>
                                {{ room.user.name }}
                              </small>
                            </div>
                            <div>
                              {{ room.session.title }}
                            </div>
                            <div style="line-height: 1.5">
                              <small>
                                <Timer :start="room.session.start_at" />
                              </small>
                            </div>
                          </div>
                        </div>
                      </template>
                    </v-list-item>
                    <v-divider v-if="(index + 1) < rooms.data.length"></v-divider>
                  </div>
                </template>
              </v-list-item-group>
            </v-list>
          </div>
          <div
            v-else
            class="px-10 py-10"
          >
            <div class="text-center">
              <Icon
                :width="48"
                :height="48"
                :color="'#757575'"
                :icon="'text-account'"
              />
            </div>
            <Empty
              title="No hay transmisiones en vivo en este momento"
              description="Tal vez en otro momento. Vuelva pronto. 👋"
            />
          </div>
        </div>
      </div>
      <div>
        <OcularSign />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

import MainStreamingService from '@/services/MainStreamingService'

require('@/services/Rooms')

@Component({
  components: {
    ViewHeader: () => import(/* webpackPrefetch: true */ '@/components/ViewHeader.vue'),
    Loading: () => import(/* webpackPrefetch: true */ '@/components/Loading.vue'),
    Empty: () => import(/* webpackPrefetch: true */ '@/views/session/resources/Empty.vue'),
    Avatar: () => import(/* webpackPrefetch: true */ '@/views/room/components/Avatar.vue'),
    Timer: () => import(/* webpackPrefetch: true */ '@/views/room/components/Timer.vue'),
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue'),
    Customer: () => import(/* webpackPrefetch: true */ '@/views/room/components/Customer.vue'),
    OcularSign: () => import(/* webpackPrefetch: true */ '@/components/OcularSign.vue'),
    SystemBar: () => import(/* webpackPrefetch: true */ '@/components/SystemBar.vue')
  },
  computed: {
    rooms () {
      return this.$store.state.rooms.list
    }
  }
})
export default class Index extends Vue {
  data () {
    return {
    customer: {
        data: null
      },
      roomId: null
    }
}
  mounted() {
    this.$store.state.rooms.item.data._id = null
    this.$rooms.indexStreamingRooms()
  }

  goToRoom(roomId) {
    this.roomId = roomId
    this.$router.replace({ path: `/rooms/${roomId}` })
  }
}
</script>
